import useLanguageTree from '~/commons/language'
const {t} = useLanguageTree()

export default {
  name: 'file.shared.permission',
  icon: () => '/static/images/ipn/file.png',
  click ({file_id}) {
    this.$router.push(`/file/${file_id}`)
  },
  body (payload) {
    const namespaced = ['notification'].concat(payload.notification_name.split('.'))
    payload.permission_level = t(payload.permission_level)
    return t(namespaced.concat(['body']).join('.'), payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/notifications/notifications/FileSharedPermission.js